import { getRestfulId } from '@/contexts/utils/getRestfulId';
import { useEnsureOutlookExternalMessageMutation } from '@/generated/graphql';
import { useMeContext } from '@shared/contexts/hooks/useMeContext';

export const useStoreOpenOutlookEmail = () => {
  const { defaultOrgId } = useMeContext();
  const [ensureOutlookExternalMessage] =
    useEnsureOutlookExternalMessageMutation({ ignoreResults: true });

  return async (
    item: Office.MessageRead,
    sharedInbox?: string
  ): Promise<string | undefined> => {
    if (!defaultOrgId) return undefined;
    const res = await ensureOutlookExternalMessage({
      variables: {
        input: {
          organizationId: defaultOrgId,
          itemId: getRestfulId(item),
          internetMessageId: item.internetMessageId,
          sharedInbox,
        },
      },
    });
    return res.data?.ensureOutlookExternalMessage;
  };
};
